import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SEOService } from '@box-core/services';
import { BOXDynamicTextElement, SeoOptions } from '@box-types';
import { deleteJsonLd } from '@box/utils';
import { AccountReferralPageService } from './account-referral-page.service';

@Component({
  selector: 'account-referral',
  templateUrl: './account-referral.page.html',
  styleUrls: ['./account-referral.page.scss'],
  providers: [AccountReferralPageService]
})
export class AccountReferralPage implements OnInit, OnDestroy {
  public referralCode: string;
  public referralLimit: number;
  public imageUrl: string;
  public referralFormControl: FormControl;
  public referralTextElements: BOXDynamicTextElement[];

  constructor(
    private accountReferralPageService: AccountReferralPageService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.referralFormControl = new FormControl('', Validators.minLength(5));
    this.imageUrl = this.accountReferralPageService.getReferralImageUrl();
    this.referralCode = this.accountReferralPageService.getReferralCode();
    this.referralLimit = this.accountReferralPageService.getReferralLimit();
    this.referralTextElements = this.accountReferralPageService.getReferralTextElements();
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  public onCopySuccess(): void {
    this.accountReferralPageService.onCopyCodeSuccess();
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
